import yaml from 'js-yaml'
import { expandEditable } from '../editable/expandEditable'

/**
 * Data processor: parse + expand a builder_fragment's build into a mountable
 * rjBuild.
 *
 * A `builder_fragment` is served (decoupled) as a Syncable Object whose
 * `data.build` is the RAW YAML template string. To embed it via a
 * `ReactiveJsonSubroot` we need a parsed object for `maybeRawAppRjBuild`, with
 * its inline `editable:` declarations already expanded to `data-builder-*` (the
 * subroot inherits the builder plugins but `expandEditable` is a JS pre-pass,
 * not something the engine runs on a fetched build).
 *
 * Fires only on `/builder_fragment/` fetches (self-filtering, like
 * `flattenEsHits`). Enriches the fetched syncable in place with `parsedBuild`,
 * which the Fragment block's YAML passes to the subroot.
 */
export const parseFragmentBuild = ({ requestContext, dataToProcess }) => {
  // C1: fragments are served as builder_unit (inline build). Block-units have no
  // `data.build`, so the build-string guard below makes this a safe no-op for them.
  if (!requestContext?.url?.includes('/builder_unit/')) {
    return dataToProcess
  }
  const buildStr = dataToProcess?.data?.build
  if (typeof buildStr !== 'string' || buildStr.trim() === '') {
    return dataToProcess
  }
  let parsed
  try {
    parsed = yaml.load(buildStr)
  } catch (err) {
    console.error('parse-fragment-build: failed to parse fragment build YAML', err)
    return dataToProcess
  }
  const parsedBuild = parsed && typeof parsed === 'object' ? expandEditable(parsed) : null
  return { ...dataToProcess, parsedBuild }
}
